export const popupStyles = {
  padding: '0 5px',
  width: '13rem',
};

export const menuItemStyles = {
  margin: 0,
  lineHeight: 'inherit',
};
